import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  OfferCategoryData,
  fetchMemberUserData,
  fetchSingleMemberUserData,
} from "../../Redux/Slice/Offer";
import CustomLoader from "../../CustomComponents/loader/CustomLoader";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import HttpClient from "../../utils/HttpClient";
import { ImCross } from "react-icons/im";
import toast from "react-hot-toast";
import { useLocation, useNavigate } from "react-router-dom";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

const headLineStyle = {
  textAlign: "center",
  fontSize: "30px",
  color: "#868e96",
  margin: "35px",
  fontWeight: "bold",
};
const initialState = {
  offerType: "",
  description: " ",
  reddemingPoints: "",
  voucherNo: "",
  voucherDesc: "",
  voucherValidity: "",
  offerValidity: "",
  howToGetOffer: "",
  offerTermsCondition: "",
};
const ImageData = {
  partnerLogo: "",
  offerCoverImage: "",
};

const Offers = () => {
  const { memberData, singleMemberData, offerCategory } = useSelector(
    (state) => state.app
  );
  const [editorData, setEditorData] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  // Member
  const [UserMemberData, setUserMemberData] = useState([]);
  const [UserMemberID, SetUserMemberID] = useState(""); //during submit needed
  // Offer
  const [OfferData, setOffeData] = useState([]);
  const [OfferID, SetOfferID] = useState(""); //during submit needed
  //banner and Logo section
  const [BannerImage, setBanner] = useState(ImageData);
  //Other inputs
  const [OfferForm, setOfferForm] = useState(initialState);
  //Edit data
  const location = useLocation();
  //updatebutton
  const [isEdit, setisEdit] = useState(false);
  const dispatch = useDispatch();
  const animatedComponents = makeAnimated();
  const navigate = useNavigate();
  const data = {
    ...OfferForm,
    ...BannerImage,
    partnerId: UserMemberID,
    partnerName: singleMemberData?.[0]?.personName,
    profileLink: singleMemberData?.[0]?.userLink,
    offerCatId: OfferID,
  };

  // final submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = {
      ...OfferForm,
      ...BannerImage,
      partnerId: UserMemberID,
      partnerName: singleMemberData?.[0]?.personName,
      profileLink: singleMemberData?.[0]?.userLink,
      offerCatId: OfferID,
    };


    const res = await HttpClient.requestData("offer", "POST", data);
    if (res && res?.status) {
      toast.success("Successfully added the offer");
      setOfferForm(initialState);
      setBanner(ImageData);
      setUserMemberData([]);
      SetUserMemberID("");
      setOffeData([]);
      SetOfferID("");
      navigate("/manage-offers");
    } else {
      toast.error("Failed to add the offer");
    }
  };

  //Update Submit
  const handleEditSubmit = async (e) => {
    e.preventDefault();
    const data = {
      ...OfferForm,
      ...BannerImage,
      partnerId: UserMemberID,
      partnerName: singleMemberData?.[0]?.personName,
      profileLink: singleMemberData?.[0]?.userLink,
      offerCatId: OfferID,
    };
    const res = await HttpClient.requestData(
      "offer/" + location?.state?._id,
      "PUT",
      data
    );
    if (res && res?.status) {
      toast.success("Updated Successfully");
      setisEdit(false);

      setTimeout(() => {
        setOfferForm(initialState);
        setBanner(ImageData);
        setUserMemberData([]);
        SetUserMemberID("");
        setOffeData([]);
        SetOfferID("");
        navigate("/manage-offers");
      }, 1500);
    } else {
      toast.error("Something went wrong! Please try again.");
    }
  };

  // data manipulation
  const handleChange = (e) => {
    const { name, value } = e.target;
    setOfferForm((prev) => ({ ...prev, [name]: value }));
    // Ensure the value is not less than 0
    // const sanitizedValue = Math.max(parseInt(value), 0);
    // setOfferForm(prev => ({ ...prev, [name]: sanitizedValue }));
  };
  const handleNumberChange = (e) => {
    const { name, value } = e.target;
    // setOfferForm(prev => ({ ...prev, [name]: value }));
    // Ensure the value is not less than 0
    const sanitizedValue = Math.max(parseInt(value), 0);
    setOfferForm((prev) => ({ ...prev, [name]: sanitizedValue }));
  };
  // get Image
  const handleImageChange = async (e) => {
    const { name, files } = e.target;
    if (files && files.length > 0) {
      // File is selected, perform image upload
      const formData = new FormData();
      formData.append("image", files[0]);
      const res = await HttpClient.fileUplode("image-upload", "POST", formData);
      if (res && res.status) {
        // Update state with the URL of the uploaded image

        setBanner((prev) => ({
          ...prev,
          [name]: res?.data?.url,
        }));
      }
    }
  };

  // member dropdwon
  const memberNameSelect = () => {
    setIsLoading(true);
    let Data = [];
    if (memberData) {
      setIsLoading(false);
      Data = memberData
        ?.filter((item) => !item?.partnerStatus)
        ?.map((item, i) => ({
          label: item?.emailId,
          value: item?._id,
        }));
    } else {
      setIsLoading(false);
    }
    setUserMemberData(Data);
  };

  const handleSelectMemberID = (selectedOption) => {
    SetUserMemberID(selectedOption ? selectedOption.value : "");
  };

  //Offer
  const OfferSelect = () => {
    setIsLoading(true);
    let Data = [];
    if (offerCategory) {
      setIsLoading(false);
      Data = offerCategory.map((item, i) => ({
        label: item?.categoryName,
        value: item?._id,
      }));
    } else {
      setIsLoading(false);
    }
    setOffeData(Data);
  };
  const handleSelectOfferID = (selectedOption) => {
    SetOfferID(selectedOption ? selectedOption.value : "");
  };

  //edit data for inputs
  useEffect(() => {
    if (location?.state) {
      SetUserMemberID(location?.state?.partnerId);
      SetOfferID(location?.state?.offerCatId);
      setBanner((prev) => ({
        ...prev,
        partnerLogo: location?.state?.partnerLogo,
        offerCoverImage: location?.state?.offerCoverImage,
      }));
      setOfferForm((prev) => ({
        ...prev,
        offerType: location?.state?.offerType,
        description: location?.state?.description,
        reddemingPoints: location?.state?.reddemingPoints,
        voucherNo: location?.state?.voucherNo,
        voucherDesc: location?.state?.voucherDesc,
        voucherValidity: location?.state?.voucherValidity,
        offerValidity: location?.state?.offerValidity,
        howToGetOffer: location?.state?.howToGetOffer,
        offerTermsCondition: location?.state?.offerTermsCondition,
      }));
      setisEdit(true);
    }
  }, [location]);

  //member
  useEffect(() => {
    memberNameSelect();
  }, [offerCategory]);
  //offer
  useEffect(() => {
    OfferSelect();
  }, [memberData]);
  useEffect(() => {
    dispatch(OfferCategoryData());
    dispatch(fetchMemberUserData());
  }, []);
  useEffect(() => {
    if (UserMemberID) {
      dispatch(fetchSingleMemberUserData(UserMemberID));
    }
  }, [UserMemberID]);

  return (
    <div>
      <CustomLoader loading={isLoading} />

      <div className="d-flex justify-content-end">
        <div className="form-header">
          <section className="piechartsBox_area mb-5 ">
            <div style={headLineStyle} className="page-headline">
              Add Offers
            </div>
            <form>
              <div className="row mb-5">
                {!location?.state && (
                  <div className="col-md-12 mt-3 ">
                    <label htmlFor="formGroupExampleInput">
                      Select Member<span className="text-danger">&nbsp;*</span>
                    </label>

                    <Select
                      closeMenuOnSelect={false}
                      components={animatedComponents}
                      options={UserMemberData}
                      onChange={handleSelectMemberID}
                      value={UserMemberData.find(
                        (option) => option.value === UserMemberID
                      )}
                    />
                  </div>
                )}
                {!UserMemberID == "" ? (
                  <div className="col-md-5 mt-3 ">
                    <label htmlFor="formGroupExampleInput">Member Name</label>
                    <input
                      readOnly
                      type="text"
                      className="form-control"
                      placeholder="Member Name"
                      name=""
                      value={singleMemberData?.[0]?.personName}
                    />
                  </div>
                ) : (
                  " "
                )}
                {!UserMemberID == "" ? (
                  <div className="col-md-7 mt-3 ">
                    <label htmlFor="formGroupExampleInput">Member Link</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Member Link"
                      name=""
                      value={singleMemberData?.[0]?.userLink}
                    />
                  </div>
                ) : (
                  ""
                )}
                {!UserMemberID == "" ? (
                  <div className="col-md-10 mt-3 ">
                    <label htmlFor="formGroupExampleInput">Company Name</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Member Link"
                      name=""
                      value={singleMemberData?.[0]?.companyName}
                    />
                  </div>
                ) : (
                  ""
                )}
                <div className="col-md-12 mt-3 ">
                  <label htmlFor="formGroupExampleInput">
                    Select Offer Category
                    <span className="text-danger">&nbsp;*</span>
                  </label>
                  {/* <select
                                        type="text"
                                        className="form-control"
                                        placeholder="Company Name Name"
                                        name=""
                                    value={Company}
                                    onChange={(e) => setCompany(e.target.value)}
                                    >
                                        <option value="" disabled>Select</option>
                                        {
                                            CompanyList?.map((item, i) => {
                                                return (<>
                                                    <option value={item?._id}>{item?.type}</option>
                                                </>)
                                            })
                                        }
                                    </select> */}
                  <Select
                    closeMenuOnSelect={false}
                    components={animatedComponents}
                    options={OfferData}
                    onChange={handleSelectOfferID}
                    value={OfferData.find((option) => option.value === OfferID)}
                  />
                </div>
                <div className="col-md-6 mt-3 ">
                  <div className="d-flex">
                    <label style={{ marginRight: "0px" }}>
                      Partner Logo:
                      <span style={{ color: "red" }}>(150 x 100)</span>
                    </label>
                  </div>

                  <input
                    type="file"
                    // className="form-control"
                    placeholder="banner"
                    name="partnerLogo"
                    // value={formFourthData.banner}
                    onChange={(e) => handleImageChange(e)}
                    required
                  />

                  <img
                    src={BannerImage?.partnerLogo}
                    alt=""
                    id="preview"
                    height="70px"
                    width="70px"
                    className="mb-2 mt-1 "
                  />
                </div>
                <div className="col-md-6 mt-3 ">
                  <div className="d-flex">
                    <label style={{ marginRight: "0px" }}>
                      Cover Image:{" "}
                      <span style={{ color: "red" }}>(310 x 145)</span>
                    </label>
                  </div>

                  <input
                    type="file"
                    className="mx-1"
                    placeholder="profilePhoto"
                    name="offerCoverImage"
                    // value={formFourthData.profilePhoto}
                    onChange={(e) => handleImageChange(e)}
                    required
                  />
                  <img
                    src={BannerImage?.offerCoverImage}
                    alt=""
                    id="preview"
                    height="70px"
                    width="70px"
                    className="mb-2 mt-1"
                  />
                </div>

                {/* OFFER OTHER MANUAL INPUTS */}
                <div className="col-md-12 mt-3 ">
                  <label htmlFor="formGroupExampleInput">
                    Offer Type<span className="text-danger">&nbsp;*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="offerType"
                    name="offerType"
                    value={OfferForm.offerType}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-12 mt-3 ">
                  <label htmlFor="formGroupExampleInput">
                    Description<span className="text-danger">&nbsp;*</span>
                  </label>
                  <textarea
                    className="form-control"
                    placeholder="Description"
                    name="description"
                    value={OfferForm?.description}
                    onChange={handleChange}
                    rows={4} // You can adjust the number of rows as needed
                  ></textarea>
                </div>

                <div className="col-md-6 mt-3 ">
                  <label htmlFor="formGroupExampleInput">
                    Reddeming Points<span className="text-danger">&nbsp;*</span>
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    placeholder="reddemingPoints"
                    name="reddemingPoints"
                    value={OfferForm.reddemingPoints}
                    onChange={handleNumberChange}
                  />
                </div>
                <div className="col-md-6 mt-3 ">
                  <label htmlFor="formGroupExampleInput">
                    Voucher No.<span className="text-danger">&nbsp;*</span>
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    placeholder="voucherNo"
                    name="voucherNo"
                    value={OfferForm.voucherNo}
                    onChange={handleNumberChange}
                  />
                </div>
                <div className="col-md-12 mt-3 ">
                  <label htmlFor="formGroupExampleInput">
                    Voucher Description
                    <span className="text-danger">&nbsp;*</span>
                  </label>
                  <textarea
                                        className="form-control"
                                        placeholder="voucherDesc"
                                        name="voucherDesc"
                                        value={OfferForm?.voucherDesc}
                                        onChange={handleChange}
                                        rows={4} // You can adjust the number of rows as needed
                                    ></textarea>
                  {/* <CKEditor
                    editor={ClassicEditor}
                    data={OfferForm?.voucherDesc}
                    onChange={(event, editor) => {
                      const data = editor.getData();
                      handleChange({
                        target: { name: "voucherDesc", value: data },
                      });
                    }}
                    config={{
                      toolbar: [
                        "bold",
                        "italic",
                        "link",
                        "|",
                        "bulletedList",
                        "numberedList",
                        "blockQuote",
                      ],
                    }}
                  /> */}
                </div>
                <div className="col-md-6 mt-3 ">
                  <label htmlFor="formGroupExampleInput">
                    voucherValidity (Hours)
                    <span className="text-danger">&nbsp;*</span>
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    placeholder="voucherValidity"
                    name="voucherValidity"
                    value={OfferForm.voucherValidity}
                    onChange={handleNumberChange}
                  />
                </div>
                <div className="col-md-6 mt-3 ">
                  <label htmlFor="formGroupExampleInput">
                    offerValidity (Days)
                    <span className="text-danger">&nbsp;*</span>
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    placeholder="offerValidity"
                    name="offerValidity"
                    value={OfferForm.offerValidity}
                    onChange={handleNumberChange}
                  />
                </div>
                <div className="col-md-12 mt-3 ">
                  <label htmlFor="formGroupExampleInput">
                    howToGetOffer<span className="text-danger">&nbsp;*</span>
                  </label>
                  {/* <textarea
                    className="form-control"
                    placeholder="howToGetOffer"
                    name="howToGetOffer"
                    value={OfferForm?.howToGetOffer}
                    onChange={handleChange}
                    rows={4} // You can adjust the number of rows as needed
                  ></textarea> */}
                  <CKEditor
                    editor={ClassicEditor}
                    data={OfferForm?.howToGetOffer}
                    onChange={(event, editor) => {
                      const data = editor.getData();
                      handleChange({
                        target: { name: "howToGetOffer", value: data },
                      });
                    }}
                    config={{
                      toolbar: [
                        "bold",
                        "italic",
                        "link",
                        "|",
                        "bulletedList",
                        "numberedList",
                        "blockQuote",
                      ],
                    }}
                  />
                </div>
                <div className="col-md-12 mt-3 ">
                  <label htmlFor="formGroupExampleInput">
                    offerTermsCondition
                    <span className="text-danger">&nbsp;*</span>
                  </label>
                  <textarea
                    className="form-control"
                    placeholder="offerTermsCondition"
                    name="offerTermsCondition"
                    value={OfferForm?.offerTermsCondition}
                    onChange={handleChange}
                    rows={4} // You can adjust the number of rows as needed
                  ></textarea>
                </div>

                {/* Button */}
                <div className="col-12 d-flex justify-content-end ">
                  {isEdit ? (
                    <div className=" d-flex ">
                      <button
                        type="submit"
                        onClick={(e) => handleEditSubmit(e)}
                        className="btn btn-primaryb mt-3 btn-grad"
                        // style={{ background: "linear-gradient(195deg, rgb(66, 66, 74), rgb(25, 25, 25))", color: "#fff" }}
                      >
                        Update Data
                      </button>
                      {/* <ImCross
                                            onClick={(e) => cancelEdit(e)}
                                            style={{ fontSize: "20px", cursor: "pointer" }} className=" mx-3 mt-4 text-danger " /> */}
                    </div>
                  ) : (
                    <button
                      type="submit"
                      onClick={(e) => handleSubmit(e)}
                      className="btn btn-primaryb mt-3"
                      style={{
                        background:
                          "linear-gradient(195deg, rgb(66, 66, 74), rgb(25, 25, 25))",
                        color: "#fff",
                      }}
                    >
                      Add Data
                    </button>
                  )}
                </div>
              </div>

              {/* Button */}
              {/* <div class="col-12 d-flex justify-content-end ">

                                {isEdit ? <div className=' d-flex '>
                                    <button
                                        type="submit"
                                        onClick={(e) => handleEditSubmit(e)}
                                        class="btn btn-primaryb mt-3 btn-grad"
                                   
                                    >
                                        Update Data
                                    </button>
                                    <ImCross
                                        onClick={(e) => cancelEdit(e)}
                                        style={{ fontSize: "20px", cursor: "pointer" }} className=" mx-3 mt-4 text-danger " />
                                </div> : <button
                                    type="submit"
                                    onClick={(e) => handleSubmit(e)}
                                    class="btn btn-primaryb mt-3"
                                    style={{ background: "linear-gradient(195deg, rgb(66, 66, 74), rgb(25, 25, 25))", color: "#fff" }}
                                >
                                    Add Data
                                </button>}

                            </div> */}
            </form>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Offers;
